import { Button } from '@saay/shadcn/components/button';
import { IconButton, Icon } from '../kit.js';
import type { ReactNode } from 'react';
import { Link, type To } from 'react-router';

export type DetailBack =
  | { readonly label: string; readonly onClick: () => void }
  | { readonly label: string; readonly state?: unknown; readonly to: To };

/**
 * The one header of the admin detail pages (merchant, buyer, organization; owner W4 decision): a
 * sticky row under the top app bar with back, the record's name, its status, and its actions.
 */
export function DetailHeader({
  actions,
  actionsLabel = 'کارها',
  back,
  meta,
  status,
  title,
  titleId,
}: {
  readonly actions?: ReactNode;
  /** The accessible name of the action group. */
  readonly actionsLabel?: string;
  /** Absent on a top-level page opened from the navigation (no list to go back to). */
  readonly back?: DetailBack;
  /** A short fact line after the status (for example the city). */
  readonly meta?: ReactNode;
  readonly status?: ReactNode;
  readonly title: ReactNode;
  readonly titleId?: string;
}) {
  return (
    <header className="admin-detail-header">
      <div className="admin-detail-header__lead">
        {back === undefined ? null : 'to' in back ? (
          <Button
            aria-label={back.label}
            nativeButton={false}
            render={
              <Link
                title={back.label}
                to={back.to}
                {...(back.state === undefined ? {} : { state: back.state })}
              />
            }
            size="icon"
            variant="ghost"
          >
            <Icon name="arrow-back" />
          </Button>
        ) : (
          <IconButton icon="arrow-back" label={back.label} onClick={back.onClick} />
        )}
        <div className="admin-detail-header__titles">
          <h1 {...(titleId === undefined ? {} : { id: titleId })}>{title}</h1>
          {status === undefined && meta === undefined ? null : (
            <div className="admin-detail-header__meta">
              {status}
              {meta === undefined ? null : <span>{meta}</span>}
            </div>
          )}
        </div>
      </div>
      {actions === undefined || actions === null ? null : (
        <div aria-label={actionsLabel} className="admin-detail-header__actions" role="group">
          {actions}
        </div>
      )}
    </header>
  );
}
